"use client";
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MeasurementModal from './MeasurementModal';
import { useProductDetails } from '../../context/ProductDetailsContext';
import { useCart } from '../../context/CartContext'; // adjust the path accordingly
import { useWishlist } from '../../context/WishlistContext';
import { UPLOAD_URL } from '../../config/config';

function ProductInfo() {
  const { product, loading } = useProductDetails();
  const { addToCart } = useCart();
  const { addToWishlist, removeFromWishlist, isInWishlist } = useWishlist();
  
  const handleAddToCart = () => {
    // const finishingIds = Array.isArray(selectedFinishing) ? [...selectedFinishing].sort() : [];
    const variantKey = [
      product.id
      // selectedBlouseSize || "-",
      // finishingIds.join(",") || "-"
    ].join("|");

    const cartItem = {
      id: product.id,
      key: variantKey,                       // ✅ unique per variant
      name: product.name,
      image: Array.isArray(product.images) ? product.images[0] : "",
      category: product.category_name || "Uncategorized",
      color: product.colors || "N/A",
      fabric: product.fabrics || "N/A",
      price: product.amount ? `${product.amount}` : "N/A",
      offer_price: product.offer_price ? `${product.offer_price}` : "N/A",
      priceValue: product.amount ? Number(String(product.amount).replace(/,/g, "")) : 0,
      quantity,                              // ✅ selected qty
        // sorted for stable key
    };
    addToCart(cartItem);    // ✅ replace qty rather than auto-increment
    navigate("/cart");
  };

  


  const navigate = useNavigate();
  const [quantity, setQuantity] = useState(1);
  const [selectedBlouseSize, setSelectedBlouseSize] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [pincode, setPincode] = useState('');
  const [pincodeStatus, setPincodeStatus] = useState(null); // null, 'valid', 'invalid'
  const [isWishlisted, setIsWishlisted] = useState(false);
  const [selectedFinishing, setSelectedFinishing] = useState([]);
  const [modalType, setModalType] = useState(null);
  
  const blouseSizes = [
    'XS (32-34)',
    'S (34-36)',
    'M (36-38)',
    'L (38-40)',
    'XL (40-42)',
    'XXL (42-44)',
    'Custom Size'
  ];

  if (loading) return <div>Loading...</div>;
if (!product) return <div>Product not found.</div>;

  const finishingOptions = product?.saree_finishings || [];


  const handleQuantityChange = (change) => {
    setQuantity(prev => Math.max(1, prev + change));
  };

  const handleBlouseSizeSelect = (size) => {
    setSelectedBlouseSize(size);
    setIsDropdownOpen(false);
  };

  const handleFinishingToggle = (optionId) => {
    setSelectedFinishing(prev => {
      if (prev.includes(optionId)) {
        return prev.filter(id => id !== optionId);
      } else {
        return [...prev, optionId];
      }
    });
  };

  const wishlisted = isInWishlist(product.id);


  const handleWishlistToggle = () => {
    const variantKey = [
                  product.id
                  // selectedBlouseSize || "-",
                  // finishingIds.join(",") || "-"
                ].join("|");
    const imgUrl = product.images[0]
                      ? `${UPLOAD_URL}/products/${product.images[0]}` // or wherever your images are served from
                      : 'fallback-image-url';
                      
    const productData = {
                  id: product.id,
                  key: variantKey,                       // ✅ unique per variant
                  name: product.name,
                  image: product.images[0],
                  category: product.category || "Uncategorized",
                  color: product.colors || "N/A",
                  fabric: product.fabrics || "N/A",
                  price: product.amount ? `${product.amount}` : "N/A",
                  priceValue: product.amount ? Number(String(product.amount).replace(/,/g, "")) : 0,
                  quantity:1,                              // ✅ selected qty
                };

    //   };
    wishlisted ? removeFromWishlist(product.id) : addToWishlist(productData);
   
    if (isWishlisted) {
      removeFromWishlist(product.id);
    } else {
      addToWishlist(productData);
    }
    setIsWishlisted(!isWishlisted);
  };

  const handleMoreFromCollection = () => {
    navigate('/products');
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Crimson Red Printed Crepe Designer Saree',
          text: 'Check out this beautiful saree!',
          url: window.location.href,
        });
      } catch (error) {
        console.log('Error sharing:', error);
      }
    } else {
      navigator.clipboard.writeText(window.location.href);
      alert('Link copied to clipboard!');
    }
  };

  const handlePincodeCheck = () => {
    if (!pincode.trim()) {
      setPincodeStatus('invalid');
      return;
    }

    // Basic validation - for demo purposes
    // In real implementation, this would be an API call
    const isValidPincode = /^\d{6}$/.test(pincode.trim());

    // Simulate some valid pincodes for demo
    const validPincodes = ['110001', '400001', '560001', '600001', '700001'];
    const isServiceable = validPincodes.includes(pincode.trim()) || isValidPincode;

    setPincodeStatus(isServiceable ? 'valid' : 'invalid');
  };

  const openMeasurementModal = (type) => {
    setModalType(type);
  };

  const closeMeasurementModal = () => {
    setModalType(null);
  };

  const handleKeyDown = (event, action, param = null) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      if (action === 'selectSize') {
        handleBlouseSizeSelect(param);
      } else if (action === 'toggleDropdown') {
        setIsDropdownOpen(!isDropdownOpen);
      } else if (action === 'wishlist') {
        handleWishlistToggle();
      } else if (action === 'finishing') {
        handleFinishingToggle(param);
      } else if (action === 'share') {
        handleShare();
      } else if (action === 'measurement') {
        openMeasurementModal(param);
      } else if (action === 'checkPincode') {
        handlePincodeCheck();
      }
    }
  };

  return (
    <>
      <div className="px-5 w-full max-w-xl min-w-60 max-md:max-w-full max-md:px-2">
        <div className="py-7 mb-0 w-full max-md:pb-24 max-md:max-w-full">
          <div className="flex flex-wrap gap-7 pt-1.5 pr-4 max-md:max-w-full max-md:gap-4">
            <div className="flex-1 shrink text-xl basis-0 min-w-60 text-neutral-700">
              <h1 className="text-neutral-700">
                {product.name}
              </h1>
            </div>

            <div className="flex gap-3 items-center">
              <button
                onClick={handleShare}
                onKeyDown={(e) => handleKeyDown(e, 'share')}
                className="flex items-center justify-center w-10 h-10 rounded-full hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300 transition-colors"
                aria-label="Share product"
              >
                <img
                  src="https://api.builder.io/api/v1/image/assets/TEMP/c705fab07a6fb088526b4f7f2c74e33ef3613114?placeholderIfAbsent=true&apiKey=e17ddfc84f414dcd9e54ab68d30c91b6"
                  alt="Share"
                  className="w-6 h-6"
                />
              </button>
              <button
                onClick={handleWishlistToggle}
                onKeyDown={(e) => handleKeyDown(e, 'wishlist')}
                className="flex items-center justify-center w-10 h-10 rounded-full hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300 transition-colors"
                aria-label={wishlisted ? "Remove from wishlist" : "Add to wishlist"}
              >
                <svg
                  viewBox="0 0 24 24"
                  className={`w-6 h-6 transition-colors ${wishlisted ? 'fill-red-500 text-red-500' : 'fill-none text-gray-600'}`}
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
                </svg>
              </button>
            </div>
          </div>

          <div className="flex flex-wrap gap-0 mt-6 min-h-[39px] max-md:-mr-3.5 max-md:max-w-full">
            <div className="flex flex-col grow shrink justify-center min-w-[304px] w-[383px]">
              <div className="flex flex-wrap gap-0 content-center items-center pr-10 max-w-full h-[19px] w-[386px] max-md:pr-5">
                {/* <div className="self-stretch pl-2 my-auto text-3xl font-medium text-neutral-700">
                  <span className="font-medium text-neutral-700">₹ {product.amount}/-</span>
                </div> */}

                <div className="self-stretch pl-2 my-auto flex items-center gap-3 flex-wrap">
                  {/* Offer / Discounted Price */}
                  <span className="text-3xl font-medium text-neutral-700">
                    ₹ {product.offer_price}/-
                  </span>

                  {/* Original Price (Striked) */}
                  <span className="text-xl text-neutral-400 line-through">
                    ₹ {product.amount}/-
                  </span>

                  {/* Discount Percentage */}
                  {Number(product.amount) > Number(product.offer_price) && (
                    <span className="text-base font-semibold text-green-600">
                      (
                      {Math.round(
                        ((Number(product.amount) - Number(product.offer_price)) /
                          Number(product.amount)) *
                          100
                      )}
                      % OFF)
                    </span>
                  )}
                </div>


                {/* <div className="self-stretch pl-1.5 my-auto text-sm text-right text-yellow-600">
                  <div className="flex flex-col items-end">
                    <span>{product.working_days}</span>
                  </div>
                </div> */}
              </div>
            </div>
          </div>

          <div className="flex overflow-hidden flex-col items-start mt-7 leading-none min-h-[37px] max-md:-mr-2 max-md:max-w-full">
            <div className="flex overflow-hidden flex-col gap-0 items-start max-w-[440px] w-[440px]">
              <div className="flex gap-2 items-center">
                <span className="self-stretch my-auto text-xl text-stone-500">
                  1,238 Sold
                </span>
                <div className="flex gap-1 justify-center items-center self-stretch my-auto text-2xl font-semibold whitespace-nowrap text-neutral-900">
                  <img
                    src="https://api.builder.io/api/v1/image/assets/TEMP/4acd787550baa7b8737e11dc729352f3b05cc6db?placeholderIfAbsent=true&apiKey=e17ddfc84f414dcd9e54ab68d30c91b6"
                    alt="Star rating"
                    className="object-contain shrink-0 self-stretch my-auto w-6 rounded-sm aspect-square"
                  />
                  <span className="self-stretch my-auto">4.5</span>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="gap-2.5 pb-1.5 mt-3.5 w-full font-medium max-md:max-w-full">
            <div className="flex w-full text-sm text-neutral-700 max-md:max-w-full">
              <label className="font-medium text-neutral-700">Saree Finishing</label>
            </div>
            <div className="flex flex-wrap gap-4 justify-start mt-2.5 w-full text-center text-neutral-700 max-md:max-w-full">
              {finishingOptions.map((option, index) => (
                <div key={index} className="grow shrink w-52 text-base min-w-60">
                  <button
                    onClick={() => handleFinishingToggle(option.label)}
                    onKeyDown={(e) => handleKeyDown(e, 'finishing', option.label)}
                    className={`flex justify-center items-start px-px py-3.5 max-w-full rounded border border-solid w-[262px] transition-colors focus:outline-none focus:ring-2 focus:ring-yellow-500 ${
                      selectedFinishing.includes(option.label)
                        ? 'bg-yellow-50 border-yellow-500'
                        : 'bg-white border-stone-300 hover:border-yellow-500'
                    }`}
                  >
                    <div className="flex flex-col items-center min-w-60 w-[260px]">
                      <span className="font-medium">
                        <span style={{ color: 'rgba(64,64,64,1)' }}>{option.label} </span>
                        <span style={{ color: 'rgba(214,154,4,1)' }}>+ ₹ {option.price}</span>
                      </span>
                    </div>
                  </button>
                </div>
              ))}
            </div>
          </div> */}

          {/* <div className="flex flex-col gap-3 pb-1.5 mt-3 w-full max-md:max-w-full">
            <div className="flex w-full font-medium max-md:max-w-full">
              <label className="flex items-center h-full">
                <span className="self-stretch my-auto text-sm font-medium text-neutral-700">
                  Blouse Size
                </span>
                <span className="self-stretch my-auto text-base font-medium text-yellow-600">
                  *
                </span>
              </label>
            </div>
            <div className="relative flex flex-col self-center pb-3 mt-3 w-full">
              <button
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                onKeyDown={(e) => handleKeyDown(e, 'toggleDropdown')}
                className="flex overflow-hidden flex-col justify-center items-start  bg-white rounded-md border border-solid border-zinc-600 py-3.5 pr-7 min-h-10 pl-4 max-md:px-5 max-md:max-w-full hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-yellow-500"
                aria-expanded={isDropdownOpen}
                aria-haspopup="listbox"
                role="combobox"
              >
                <div className="flex justify-between items-center w-full">
                  <span className="text-xs font-medium leading-none text-neutral-700">
                    {selectedBlouseSize || '--Select--'}
                  </span>
                  <img
                    src="https://api.builder.io/api/v1/image/assets/TEMP/6bf8979fd8477ba476d80bedd3d91c08d6698add?placeholderIfAbsent=true&apiKey=e17ddfc84f414dcd9e54ab68d30c91b6"
                    alt=""
                    className={`object-contain w-3 aspect-[0.92] transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`}
                  />
                </div>
              </button>

              {isDropdownOpen && (
                <div className="absolute top-full left-0 right-0 z-10 bg-white border border-solid border-zinc-600 rounded-md mt-1 shadow-lg" role="listbox">
                  {blouseSizes.map((size, index) => (
                    <button
                      key={index}
                      onClick={() => handleBlouseSizeSelect(size)}
                      onKeyDown={(e) => handleKeyDown(e, 'selectSize', size)}
                      className="w-full px-4 py-3 text-left text-xs font-medium text-neutral-700 hover:bg-gray-50 focus:outline-none focus:bg-yellow-50"
                      role="option"
                      aria-selected={selectedBlouseSize === size}
                    >
                      {size}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div> */}

          {/* <div className="flex py-2 w-full text-xs font-medium text-yellow-600 max-md:max-w-full">
            <div className="flex flex-wrap gap-4 h-full min-w-60">
              <button
                onClick={() => openMeasurementModal('petticoat')}
                onKeyDown={(e) => handleKeyDown(e, 'measurement', 'petticoat')}
                className="font-medium hover:underline focus:outline-none focus:underline"
              >
                Petticoat Measurements
              </button>
              <button
                onClick={() => openMeasurementModal('blouse')}
                onKeyDown={(e) => handleKeyDown(e, 'measurement', 'blouse')}
                className="font-medium hover:underline focus:outline-none focus:underline"
              >
                Blouse Measurements
              </button>
            </div>
          </div> */}

          {/* <section className="mt-5 w-full max-md:max-w-full">
            <div className="w-full">
              <div className="flex flex-col justify-center w-full text-sm font-medium min-h-11 text-neutral-700 max-md:max-w-full">
                <div className="flex flex-wrap gap-0 w-full min-h-11">
                  <div className="flex flex-col justify-center py-3.5">
                    <h3 className="pl-4 min-h-4 font-medium text-neutral-700">
                      Check Delivery for COD (India)
                    </h3>
                  </div>
                </div>
              </div>
              <div className="flex flex-col justify-center items-start max-w-full min-h-[34px] w-full">
                <div className="px-2 max-w-[346px] min-h-[34px] w-full max-w-[342px]">
                  <div className="relative w-full">
                    <div className="z-0 pb-px w-full text-sm leading-none border-b border-solid border-b-zinc-600 min-h-[34px] text-stone-300">
                      <div className="flex flex-col justify-center items-start py-2.5 w-full max-md:pr-5">
                        <input
                          type="text"
                          value={pincode}
                          onChange={(e) => {
                            setPincode(e.target.value);
                            setPincodeStatus(null); // Reset status when typing
                          }}
                          placeholder="Enter Pincode here..."
                          className="w-full bg-transparent border-none outline-none leading-4 text-stone-300 placeholder-stone-300 focus:text-neutral-700"
                          aria-label="Enter pincode for delivery check"
                          maxLength="6"
                        />
                      </div>
                    </div>
                    <div className="flex absolute -right-2 z-0 flex-col justify-center items-center max-w-full text-sm font-medium text-center top-[7px] w-[100px]">
                      <button
                        onClick={handlePincodeCheck}
                        onKeyDown={(e) => handleKeyDown(e, 'checkPincode')}
                        className="text-yellow-600 hover:underline focus:outline-none focus:underline"
                      >
                        Check Now
                      </button>
                    </div>
                    
                    
                    {pincodeStatus && (
                      <div className="flex absolute -right-12 z-0 flex-col justify-center items-center top-[7px] w-[20px]">
                        {pincodeStatus === 'valid' ? (
                          <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                          </svg>
                        ) : (
                          <svg className="w-5 h-5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                          </svg>
                        )}
                      </div>
                    )}
                  </div>

                  
                  {pincodeStatus && (
                    <div className="mt-2 text-xs">
                      {pincodeStatus === 'valid' ? (
                        <span className="text-green-600">✓ Delivery available to this pincode</span>
                      ) : (
                        <span className="text-red-600">✗ Service not available to this pincode</span>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section> */}

          <div className="flex flex-col gap-4 mt-9 w-full text-center text-neutral-700 max-md:max-w-full">
            <div className="flex gap-4 w-full">
              <div className="text-base whitespace-nowrap min-h-[52px]">
                <div className="flex gap-0 items-start py-px pr-1 pl-px bg-white rounded border border-solid border-stone-300 min-h-[52px]">
                  <button
                    onClick={() => handleQuantityChange(-1)}
                    className="flex flex-col justify-center items-center px-1.5 py-4 text-stone-300 hover:text-neutral-700 focus:outline-none focus:text-neutral-700"
                    aria-label="Decrease quantity"
                  >
                    -
                  </button>
                  <div className="flex overflow-hidden flex-col justify-center self-stretch px-1.5 py-4 bg-white w-[70px]">
                    <div className="overflow-hidden w-full">
                      <span className="text-base text-neutral-700">{quantity}</span>
                    </div>
                  </div>
                  <button
                    onClick={() => handleQuantityChange(1)}
                    className="flex flex-col justify-center items-center px-1.5 py-4 text-neutral-700 hover:text-yellow-600 focus:outline-none focus:text-yellow-600"
                    aria-label="Increase quantity"
                  >
                    +
                  </button>
                </div>
              </div>

               <button
                  className="flex-1 flex justify-center items-center text-sm min-h-[52px] bg-white rounded border border-solid border-zinc-600 hover:bg-zinc-600 hover:text-white focus:outline-none focus:ring-2 focus:ring-yellow-500 transition-colors"
                  onClick={handleAddToCart}
                >
                  <span>Add To Cart</span>
                </button>

              {/* <button onClick={handleAddToCart} className="flex-1 flex justify-center items-center text-sm text-white min-h-[52px] rounded border border-solid bg-zinc-600 border-zinc-600 hover:bg-white hover:text-zinc-600 focus:outline-none focus:ring-2 focus:ring-yellow-500 transition-colors">
                <span>Buy Now</span>
              </button> */}
            </div>
          </div>

          <div className="flex flex-col items-center mt-6 w-full max-md:mt-10 max-md:max-w-full">
            <div className="w-full">
              <div className="flex flex-col items-start w-full">
                <div className="flex flex-wrap gap-4 w-full mb-4">
                  <div className="flex items-center px-4 py-2 bg-slate-50 min-h-[46px]">
                    <img
                      src="https://api.builder.io/api/v1/image/assets/TEMP/b4ad2d687cdcda3dee413bed9b7f1f6a534cb550?placeholderIfAbsent=true&apiKey=e17ddfc84f414dcd9e54ab68d30c91b6"
                      alt="Custom Fit"
                      className="object-contain aspect-square w-[30px]"
                    />
                    <span className="flex flex-col items-center self-stretch pl-2 my-auto text-xs font-medium text-center text-neutral-700">
                      Custom Fit
                    </span>
                  </div>
                  <div className="flex items-center px-4 py-2 bg-slate-50 min-h-[46px]">
                    <img
                      src="https://api.builder.io/api/v1/image/assets/TEMP/94e122a7604e6b5491a3da3c06666602a3b59b4c?placeholderIfAbsent=true&apiKey=e17ddfc84f414dcd9e54ab68d30c91b6"
                      alt="Ready to Ship"
                      className="object-contain aspect-square w-[30px]"
                    />
                    <span className="flex flex-col items-center self-stretch pl-2 my-auto text-sm font-medium text-center text-neutral-700">
                      90% Ready To Ship
                    </span>
                  </div>
                  <div className="flex items-center px-4 py-2 bg-slate-50 min-h-[46px]">
                    <img
                      src="https://api.builder.io/api/v1/image/assets/TEMP/6f9c56ef0ef30e31af00b0a7133e1024417abcc3?placeholderIfAbsent=true&apiKey=e17ddfc84f414dcd9e54ab68d30c91b6"
                      alt="Best Price"
                      className="object-contain aspect-square w-[30px]"
                    />
                    <span className="flex flex-col items-center self-stretch pl-2 my-auto text-xs font-medium text-center text-neutral-700">
                      Best Price
                    </span>
                  </div>
                </div>

                <div className="flex flex-wrap gap-4 w-full">
                  <div className="flex items-center px-4 py-2 bg-slate-50 min-h-[46px]">
                    <img
                      src="https://api.builder.io/api/v1/image/assets/TEMP/2a8ff159dc52dc33c363ebb32beb0ec9daa72446?placeholderIfAbsent=true&apiKey=e17ddfc84f414dcd9e54ab68d30c91b6"
                      alt="Original Quality"
                      className="object-contain aspect-square w-[30px]"
                    />
                    <span className="flex flex-col items-center self-stretch pl-2 my-auto text-sm font-medium text-center text-neutral-700">
                      100% Original Quality
                    </span>
                  </div>
                  <div className="flex items-center px-4 py-2 bg-slate-50 min-h-[46px]">
                    <img
                      src="https://api.builder.io/api/v1/image/assets/TEMP/f8b62d29c68e8ab4dc4a4367925b15a233a71a0d?placeholderIfAbsent=true&apiKey=e17ddfc84f414dcd9e54ab68d30c91b6"
                      alt="Purchase Protection"
                      className="object-contain aspect-square w-[30px]"
                    />
                    <span className="flex flex-col items-center self-stretch pl-2 my-auto text-sm font-medium text-center text-neutral-700">
                      100% Purchase Protection
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <button
            onClick={handleMoreFromCollection}
            className="flex flex-row gap-4 justify-between items-center px-3 py-3.5 mt-6 mb-6 text-sm font-medium rounded-md border border-solid border-zinc-600 text-neutral-700 w-full hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-yellow-500 transition-colors max-md:mb-2.5"
          >
            <span className="font-medium text-neutral-700">
              More from the Collection
            </span>
            <img
              src="https://api.builder.io/api/v1/image/assets/TEMP/cd14ac232c95c3ac3307e0eec9010f9082658d94?placeholderIfAbsent=true&apiKey=e17ddfc84f414dcd9e54ab68d30c91b6"
              alt=""
              className="object-contain shrink-0 aspect-[0.6] w-[9px]"
            />
          </button>
        </div>
      </div>

      <MeasurementModal
        isOpen={modalType !== null}
        onClose={closeMeasurementModal}
        type={modalType}
      />
    </>
  );
}

export default ProductInfo;
